import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { ReactNativeMessageType } from 'types';
import { isMobileApp } from 'utils/common';
import { parseRnMessageData } from 'utils/mobileApp/parseRnMessageData';

const USER_PROFILE_PATH = '/user/profile/';

/**
 * When RN has no saved fast sign-in method, it sends `redirectToUserProfile`.
 * Web navigates to the profile / fast sign-in setup screen.
 */
export const useRedirectToUserProfile = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isMobileApp()) return;

    const handleMessage = (event: Event) => {
      const messageEvent = event as MessageEvent;
      const data = parseRnMessageData(messageEvent.data);
      if (data?.type !== ReactNativeMessageType.RedirectToUserProfile) return;

      navigate(USER_PROFILE_PATH);
    };

    window.addEventListener('message', handleMessage);
    document.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
      document.removeEventListener('message', handleMessage);
    };
  }, [navigate]);
};
